var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "date_range_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.391,
    height: 21.39,
    viewBox: "0 0 21.391 21.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7538",
    "data-name": "Path 7538",
    d: "M0,0H21.39V21.39H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7539",
    "data-name": "Path 7539",
    d: "M6.565,10.021H8.348V11.8H6.565ZM19.043,5.565V18.043a1.788,1.788,0,0,1-1.783,1.783H4.783A1.782,1.782,0,0,1,3,18.043L3.009,5.565A1.774,1.774,0,0,1,4.783,3.783h.891V2H7.456V3.783h7.13V2h1.783V3.783h.891A1.788,1.788,0,0,1,19.043,5.565ZM4.783,7.348H17.26V5.565H4.783Zm12.478,10.7V9.13H4.783v8.913ZM13.7,11.8h1.783V10.021H13.7Zm-3.565,0h1.783V10.021H10.13Z",
    transform: "translate(-0.326 -0.217)",
    fill: "#a2adbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateCalendarIcon);
export default __webpack_public_path__ + "static/media/update_calendar_icon.e5baf37bbaf08e09a450095ebf1d8560.svg";
export { ForwardRef as ReactComponent };